import { LoadState } from "../../../constants/enums";

export interface IOperatingStatementsState {
  list: IOperatingStatement[];
  loading: LoadState;
  totalRecords: number;
}

export interface IOperatingStatement {
   


  
    "prefix_gl_code_name": string | null;
    "date": string | null;
    debit_amount: string | null
    credit_amount: string | null;
    "amount":string | null;
    "account_type": string | null;
    "report_heading_account": string | null;

}


export const initialOperatingStatementsState: IOperatingStatementsState = {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
}